<div class="container">
    <div class="row">
        <div class="notauthenticated col-12">
            <div class="d-flex flex-column align-items-center my-5">
                <h1>Accès non autorisé</h1>
                <h2>Vous n’avez pas les droits pour accéder à cette partie de l'application. Contactez votre administrateur.</h2>
            </div>
            <div class="bouton">
                <button class="btn btn-primary bouton" (click)="logout()">Changer de compte</button>
            </div>
        </div>
    </div>
</div>
